import { IGlobalState } from '../../../Root/store/appReducer'

export const getSignUpCodes = (state: IGlobalState) => state.signUpCodeAdmin?.codes
export const getSignUpCodesLoading = (state: IGlobalState) => state.signUpCodeAdmin?.loading
export const getSignUpCodesCreating = (state: IGlobalState) => state.signUpCodeAdmin?.creating
export const getSignUpCodesUpdating = (state: IGlobalState) => state.signUpCodeAdmin?.updating
export const getSignUpCodesDeleting = (state: IGlobalState) => state.signUpCodeAdmin?.deleting
